import { ControlNumberField } from 'components/Form';
import { LabeledValue } from 'components/LabeledValue/LabeledValue';
import type { ConstructionTypeAttributeData, Maybe } from 'gql/graphql';
import { cnMixSpace, Grid, GridItem } from 'uikit';
import { formatNumberToRu } from 'utils';
import { replacerCost } from 'utils/replacerCost';

import type { Control } from 'react-hook-form';

interface IParametersPriceOptionsProps {
    params?: Maybe<ConstructionTypeAttributeData[]>;
    disabled: boolean;
    isUpdateForm?: boolean;
    control?: Control;
}

const marginBs = cnMixSpace({ mB: 's' });

export const ParametersPriceOptions = (props: IParametersPriceOptionsProps) => {
    const { params, disabled, isUpdateForm, control } = props;

    return (
        <Grid style={{ width: '100%', maxWidth: '630px' }}>
            <GridItem className={marginBs}>
                <div className={marginBs} style={{ fontSize: '14px' }}>
                    Процент прочих в УЕР по главам 1-7, %
                </div>
                {params?.map((paramsEl, index) => {
                    const { constructionType } = paramsEl;

                    return (
                        <GridItem className={marginBs} key={constructionType?.id}>
                            {isUpdateForm && (
                                <ControlNumberField
                                    name={`constructionTypeAttributes.${index}.uerOthersPercent`}
                                    label={constructionType?.name}
                                    labelPosition="left"
                                    control={control}
                                    size="s"
                                    style={{ width: 675 }}
                                    disabled={disabled}
                                    required
                                    rules={{
                                        validate: (value: number | string | null) => {
                                            const inputValueNumber = replacerCost(value);

                                            return !(!inputValueNumber || inputValueNumber < 0);
                                        },
                                    }}
                                />
                            )}

                            {!isUpdateForm && (
                                <LabeledValue
                                    label={constructionType?.name}
                                    value={`${formatNumberToRu(paramsEl?.uerOthersPercent ?? 0, 2)}`}
                                />
                            )}
                        </GridItem>
                    );
                })}
            </GridItem>

            <GridItem>
                <div className={marginBs} style={{ fontSize: '14px' }}>
                    Северная надбавка, %
                </div>
                {params?.map((paramsEl, index) => {
                    const { constructionType } = paramsEl;

                    return (
                        <GridItem className={marginBs} key={constructionType?.id}>
                            {isUpdateForm && (
                                <ControlNumberField
                                    name={`constructionTypeAttributes.${index}.northernAllowancePercent`}
                                    label={constructionType?.name}
                                    labelPosition="left"
                                    control={control}
                                    size="s"
                                    max={100}
                                    style={{ width: 675 }}
                                    disabled={disabled}
                                />
                            )}
                            {!isUpdateForm && (
                                <LabeledValue
                                    label={constructionType?.name}
                                    value={`${formatNumberToRu(paramsEl?.northernAllowancePercent ?? 0, 2)}`}
                                />
                            )}
                        </GridItem>
                    );
                })}
            </GridItem>
        </Grid>
    );
};

ParametersPriceOptions.displayName = 'ParametersPriceOptions';
